import React from 'react';
import PropTypes from 'prop-types';
import {Image} from '@learningblocks/shared-components';
import {DesignChapter} from '@learningblocks/storybook-components';
import {Utilities} from '@learningblocks/exp-constants';
const {DESIGN} = Utilities;

import {GroupA} from '../GroupA';
import {GroupC} from '../GroupC';
import {GroupE} from '../GroupE';
import {Outcome} from '../Outcome';
import {Technique} from '../Technique';
import {ExperimentStep} from '../ExperimentStep';

export function SlideTree(props) {
  const groupA = (params) => {
    return (
      <GroupA
        key={params.groupId}
        className='d-view_group'
        {...params}
        startNode={
          <DesignChapter.StartNode outcomeNode={DesignChapter.Outcome} />
        }
        jointNode={<DesignChapter.JointNode outcomeNode={Outcome} />}
        endNode={<DesignChapter.EndNode imageNode={Image} />}
      />
    );
  };

  const groupB = (params) => {
    return (
      <DesignChapter.GroupB
        key={params.groupId}
        className='d-view_group'
        {...params}
        stepNode={
          <DesignChapter.StepNode
            experimentStepNode={DesignChapter.ExperimentStep}
          />
        }
      />
    );
  };

  const groupC = (params) => {
    return (
      <GroupC
        key={params.groupId}
        groupId={params.groupId}
        className='d-view_group'
        {...params}
        stepNode={
          <DesignChapter.StepNode experimentStepNode={ExperimentStep} />
        }
      />
    );
  };

  const groupD = (params) => {
    return (
      <DesignChapter.GroupD
        key={params.groupId}
        className='d-view_group'
        {...params}
        titleNode={
          <DesignChapter.TitleNode techniqueNode={DesignChapter.Technique} />
        }
        boxNode={
          <DesignChapter.BoxNode techniqueNode={DesignChapter.Technique} />
        }
        jointNode={
          <DesignChapter.JointNode outcomeNode={DesignChapter.Outcome} />
        }
      />
    );
  };

  const groupE = (params) => {
    return (
      <GroupE
        key={params.groupId}
        className='d-view_group'
        {...params}
        titleNode={<DesignChapter.TitleNode techniqueNode={Technique} />}
        boxNode={<DesignChapter.BoxNode techniqueNode={Technique} />}
        jointNode={<DesignChapter.JointNode outcomeNode={Outcome} />}
      />
    );
  };

  const renderGroupByType = (group) => {
    switch (group.groupType) {
      case DESIGN.GROUP.A:
        return groupA(group);
      case DESIGN.GROUP.B:
        return groupB(group);
      case DESIGN.GROUP.C:
        return groupC(group);
      case DESIGN.GROUP.D:
        return groupD(group);
      case DESIGN.GROUP.E:
        return groupE(group);
      default:
        return <div>{group.groupType} group under construction </div>;
    }
  };

  return props.slideTree.map(renderGroupByType);
}

SlideTree.propTypes = {
  /**
   * Array of Groups
   */
  slideTree: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * uniqueId of Group
       */
      groupId: PropTypes.number,
      /**
       * Type of Group
       */
      groupType: PropTypes.oneOf([
        'GROUP_A',
        'GROUP_B',
        'GROUP_C',
        'GROUP_D',
        'GROUP_E',
      ]),
      /**
       * List of Nodes to display in Group
       */
      groupNodes: PropTypes.arrayOf(PropTypes.object),
    })
  ),
};
